import { render, staticRenderFns } from "./admin-dashboard.vue?vue&type=template&id=0677d410&scoped=true&"
import script from "./admin-dashboard.component.ts?vue&type=script&lang=ts&"
export * from "./admin-dashboard.component.ts?vue&type=script&lang=ts&"
import style0 from "./admin-dashboard.scss?vue&type=style&index=0&id=0677d410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0677d410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0677d410')) {
      api.createRecord('0677d410', component.options)
    } else {
      api.reload('0677d410', component.options)
    }
    module.hot.accept("./admin-dashboard.vue?vue&type=template&id=0677d410&scoped=true&", function () {
      api.rerender('0677d410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin-dashboard/admin-dashboard.vue"
export default component.exports